import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { MenuItem, ListItemIcon } from '@mui/material';
import AbcRoundedIcon from '@mui/icons-material/AbcRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import CustomMenu from '../../../../Components/CustomMenu';

const TemplateMenu = function TemplateMenu({
  anchor = null,
  onClose = () => {},
  onRename = () => {},
  onDelete = () => {},
}) {
  const intl = useIntl();

  return (
    <CustomMenu open={Boolean(anchor)} anchor={anchor} close={onClose}>
      <MenuItem
        onClick={() => {
          onRename();
          onClose();
        }}
      >
        <ListItemIcon>
          <AbcRoundedIcon fontSize="small" />
        </ListItemIcon>
        {intl.messages.RENAME}
      </MenuItem>
      <MenuItem onClick={onDelete}>
        <ListItemIcon>
          <DeleteRoundedIcon fontSize="small" />
        </ListItemIcon>
        {intl.messages.REMOVE}
      </MenuItem>
    </CustomMenu>
  );
};

TemplateMenu.propTypes = {
  anchor: PropTypes.object,
  onClose: PropTypes.func,
  onRename: PropTypes.func,
  onDelete: PropTypes.func,
};

export default TemplateMenu;
